export default __webpack_public_path__ + "static/media/approch4.ab2ef707.webp";